"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarouselWidget = void 0;
var tslib_1 = require("tslib");
var ArrowTriangleLeftIcon_1 = require("@tableau/icons/ArrowTriangleLeftIcon");
var ArrowTriangleRightIcon_1 = require("@tableau/icons/ArrowTriangleRightIcon");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var ButtonWidget_1 = require("../Button/ButtonWidget");
var ButtonWidgetShim_1 = require("../Button/ButtonWidgetShim");
var CarouselStyleName = TypeStyle.style({
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
});
var ButtonStyleName = TypeStyle.style({
    height: 30,
    width: 30,
    minWidth: "30px !important",
    padding: "0 !important",
    $nest: {
        '& svg': { verticalAlign: 'middle' },
    }
});
var CarouselWidget = function (_a) {
    var children = _a.children, id = _a.id, nextButtonTitle = _a.nextButtonTitle, onNextClick = _a.onNextClick, onPreviousClick = _a.onPreviousClick, prevButtonTitle = _a.prevButtonTitle, role = _a.role, style = _a.style;
    var _b = React.useState(false), focusWithin = _b[0], setFocusWithin = _b[1];
    var prevMonthButton = React.createElement(ButtonWidgetShim_1.ButtonWidget, { buttonType: ButtonWidget_1.ButtonType.LowEmphasis, className: ButtonStyleName, children: React.createElement(ArrowTriangleLeftIcon_1.ArrowTriangleLeftIcon, { size: 18, "aria-hidden": true }), onClick: onPreviousClick, testId: 'stepper-left', title: prevButtonTitle });
    var nextMonthButton = React.createElement(ButtonWidgetShim_1.ButtonWidget, { buttonType: ButtonWidget_1.ButtonType.LowEmphasis, className: ButtonStyleName, children: React.createElement(ArrowTriangleRightIcon_1.ArrowTriangleRightIcon, { size: 18, "aria-hidden": true }), onClick: onNextClick, testId: 'stepper-right', title: nextButtonTitle });
    return (React.createElement("div", { className: CarouselStyleName, onBlur: function () { return setFocusWithin(false); }, onFocus: function () { return setFocusWithin(true); }, style: style },
        prevMonthButton,
        React.createElement("span", { id: id, role: role, "aria-live": focusWithin ? 'assertive' : 'off', "aria-atomic": true }, children),
        nextMonthButton));
};
exports.CarouselWidget = CarouselWidget;
exports.CarouselWidget.displayName = 'CarouselWidget';
//# sourceMappingURL=CarouselWidget.js.map